import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const HighlightedText = styled(Text)`
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  background: linear-gradient(269deg, #F16262 -10.35%, #743DDC 106.34%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const HighlightedTextWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 194px;
  padding: 4px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 20px;
  background: var(--Maroon-M50, #FBE9F6);
  margin-bottom: 12px;
`;

export const HeadingText = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
`;